import { createReducer } from '@reduxjs/toolkit';
import {
    setPersonalizationStep,
    setPreviewStep,
    setToolbar,
    resetToolbar,
    setActiveObject,
    setCanvasDimensions,
} from './action';
import type { UIState } from './state';
import initialUIState, { Step, ToolbarType } from './state';
import { cleared } from '../General/action';

export const uiReducer = createReducer<UIState>(initialUIState, (builder) => {
    builder.addCase(setPersonalizationStep, (state) => ({
        ...state,
        step: Step.PERSONALIZE,
    }));

    builder.addCase(cleared, () => ({
        ...initialUIState,
    }));

    builder.addCase(setPreviewStep, (state) => ({
        ...state,
        step: Step.PREVIEW,
    }));

    builder.addCase(setActiveObject, (state, { payload }) => ({
        ...state,
        activeObjectId: payload,
        hasActiveObject: Boolean(payload),
        lastActiveObjectId: state.activeObjectId ?? payload,
    }));

    builder.addCase(setToolbar, (state, { payload }) => ({
        ...state,
        toolbar: payload,
    }));

    builder.addCase(setCanvasDimensions, (state, { payload }) => ({
        ...state,
        canvasDimensions: {
            ...payload,
            scale: Math.min(payload.scaleX, payload.scaleY),
            valid: payload.canvasWidth > 0 && payload.canvasHeight > 0,
        },
    }));

    builder.addCase(resetToolbar, (state) => {
        if (state.toolbar === ToolbarType.TEXT) {
            return state;
        }

        return ({
            ...state,
            toolbar: undefined,
        });
    });
});
